import axios from "axios";
import {
  saveImageFromMerchant,
  uploadImageFromMerchant,
} from "../services/api/merchant/merchantApi";
import { string } from "yup";
import jwtDecode from "jwt-decode";
import Cookies from "js-cookie";
import {
  BOOKING_HOTEL_PLATFORM,
  BOOKING_PLATFORM,
  FNB_PLATFORM,
  KVRID_HOTEL,
  RETAIL_PLATFORM, WEBORDER,
} from "./constant";

const aliasPlatform = (platform) => {
  try {
    switch (platform) {
      case RETAIL_PLATFORM:
        return RETAIL_PLATFORM;
      case "kiotonline":
        return "ko";
      case FNB_PLATFORM:
        return FNB_PLATFORM;
      case BOOKING_PLATFORM:
        return BOOKING_PLATFORM;
      case BOOKING_HOTEL_PLATFORM:
        return BOOKING_HOTEL_PLATFORM;
      case WEBORDER:
        return WEBORDER
      default:
        return "";
    }
  } catch (e) {
    console.log("ex", e);
  }
};

const getMerchantForTracking = (token) => {
  if (!token) {
    return "0";
  }
  const decodeJwt = jwtDecode(token);
  return decodeJwt.merchant_ref_id || "0";
};

const getPlatformByToken = (token) => {
  if (!token) {
    return "retail";
  }
  const decodeJwt = jwtDecode(token);
  const platform = decodeJwt.kvsource.toLowerCase();
  if (platform === BOOKING_PLATFORM && decodeJwt.kvrindid === KVRID_HOTEL) {
    return BOOKING_HOTEL_PLATFORM;
  }
  return platform;
};

const checkPlatformKeiviHiddenFeature = (is_keivi_region, platform) => {
  return !!is_keivi_region
}

const isMobile = () => {
  let check = false;
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
};

const uploadAndSaveImage = async (file, merchantInfo) => {
  const formData = new FormData();
  formData.append("merchant_id", merchantInfo.id || "");
  file && formData.append("image", file);
  formData.append("folder", "images_web_builder");
  formData.append("width", "512");
  formData.append("height", "512");
  let response_logo;
  try {
    response_logo = await uploadImageFromMerchant(formData);
  } catch (err) {
    response_logo = err.response;
  }
  // if (response_logo.status === 200) {
  //   await saveImageFromMerchant({
  //     name: response_logo.data.data.origin.name,
  //     origin_url: response_logo.data.data.origin.url,
  //   });
  // }
  return response_logo;
};
const uploadImage = async (file, merchantInfo) => {
  const formData = new FormData();
  formData.append("merchant_id", merchantInfo.id || "");
  file && formData.append("image", file);
  formData.append("folder", "images_web_builder");
  formData.append("width", "512");
  formData.append("height", "512");
  let response_logo;
  try {
    response_logo = await uploadImageFromMerchant(formData);
  } catch (err) {
    response_logo = err.response;
  }
  return response_logo;
};

const getImageInfo = async (url) => {
  const img = new Image();
  img.src = url;
  await img.decode();
  return img;
};

const getSizeOfBlobOrFile = (bytes) => {
  const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  if (bytes === 0) {
    return {
      size: 0,
      type: sizes[0],
    };
  }

  const i = Math.floor(Math.log(bytes) / Math.log(1024));

  return {
    size: Math.round(bytes / Math.pow(1024, i)),
    type: sizes[i],
  };
};

const convertStringToSnakeCase = (str) => {
  return (
    str &&
    str
      .match(
        /[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g
      )
      .map((x) => x.toLowerCase())
      .join("_")
  );
};

const setTokenInfo = ({ code, platform, merchantId, branchId }) => {
  Cookies.set("mykiot_access_token", code);
  Cookies.set("mykiot_auth_code", code);
  Cookies.set("mykiot_platform", platform);
  Cookies.set("mykiot_merchant_id", merchantId);
  Cookies.set("mykiot_branch_id", branchId);

  localStorage.setItem("mykiot_access_token", code);
  localStorage.setItem("mykiot_auth_code", code);
  localStorage.setItem("mykiot_platform", platform);
  localStorage.setItem("mykiot_merchant_id", merchantId);
  localStorage.setItem("mykiot_branch_id", branchId);
};

const getToken = () => {
  const url = new URL(window.location.href);
  // Getting search parameters
  const queryParams = url.searchParams;

  if(queryParams.get("access_token")) {
    return queryParams.get("access_token");
  }
  if(queryParams.get("code")) {
    return queryParams.get("code");
  }

  if (
    window.localStorage &&
    (window.localStorage.getItem("mykiot_access_token") ||
      localStorage.getItem("mykiot_auth_code"))
  ) {
    return (
      localStorage.getItem("mykiot_access_token") ||
      localStorage.getItem("mykiot_auth_code")
    );
  }
};

const getParamsByKey = (key) => {
  const url = new URL(window.location.href);
  // Getting search parameters
  const queryParams = url.searchParams;
  switch (key) {
    case "platform":
      return (
        Cookies.get("mykiot_platform") ||
        localStorage.getItem("mykiot_platform") ||
        queryParams.get("platform")
      );
    default:
      return "";
  }
};

const getPlatform = () => {
  return localStorage.getItem("mykiot_platform") || "retail";
};
export {
  aliasPlatform,
  isMobile,
  uploadAndSaveImage,
  uploadImage,
  getImageInfo,
  getSizeOfBlobOrFile,
  getMerchantForTracking,
  convertStringToSnakeCase,
  setTokenInfo,
  getToken,
  getParamsByKey,
  getPlatform,
  getPlatformByToken,
  checkPlatformKeiviHiddenFeature,
};
